import React from 'react'
import { useTranslation } from 'react-i18next'

import Image from 'components/Form/Image'

import invertColor from '../../../../../../util/invertColor'

import './Preview.scss'

const Preview = ({
    colorTheme,
    fontFamily,
    fields = [],
    logoImage,
    headerText = '',
    descriptionText = '',
    buttonText = '',
    linkPrivacyPolicyLink = '',
    additionalNotes = '',
}) => {
    const { t } = useTranslation()

    return (
        <div className="lead-form-form-review">
            {!!logoImage ? <Image className="logo-image" src={logoImage} alt="logo" /> : null}
            {!!headerText.length && (
                <div className="header" style={{ fontFamily: `"${fontFamily || 'Roboto'}", sans-serif` }}>
                    {headerText}
                </div>
            )}
            {!!descriptionText.length && (
                <div className="description" style={{ fontFamily: `"${fontFamily || 'Roboto'}", sans-serif` }}>
                    {descriptionText}
                </div>
            )}
            <ul className="fields">
                {fields.map(field => (
                    <li key={field.key} className={field.type}>
                        <p>{t(field.label)}</p>
                        <div />
                    </li>
                ))}
            </ul>
            {!!linkPrivacyPolicyLink.length && (
                <div className="privacy">
                    <span />
                    &nbsp;Agree with&nbsp;
                    <a href={linkPrivacyPolicyLink} target="_blank" rel="noopener noreferrer">
                        Privacy Policy
                    </a>
                </div>
            )}
            {!!additionalNotes && <div className="additional-notes">{additionalNotes}</div>}
            {!!buttonText.length && (
                <div className="button-wrapper">
                    <button
                        style={{
                            backgroundColor: colorTheme,
                            color: invertColor(colorTheme, true),
                            fontFamily: `"${fontFamily || 'Roboto'}", sans-serif`,
                        }}
                    >
                        {buttonText}
                    </button>
                </div>
            )}
        </div>
    )
}

export default Preview
